<div  class="row padding-bet">
   <div [innerHTML]="componentData.content" class="component col-12"></div>
</div>
